<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    :class="['custom-sidebar', 'items-no-padding', sidebarClass]"
    spacer
    v-model="isSidebarActive"
  >
    <div :id="`loading-${name}`" class="vs-con-loading__container">
      <div class="pt-4 px-4 flex items-center justify-between" :style="titleStyle">
        <span class="sidebar-title">{{ title }}</span>
        <feather-icon
          icon="XIcon"
          @click.stop="close"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vue-perfect-scrollbar
        class="scroll-sidebar "
        :settings="settings"
      >
        <div>
          <slot></slot>
        </div>
        <div class="items-center pt-2 mb-2">
          <slot name="footer"></slot>
        </div>
      </vue-perfect-scrollbar>

      <!-- <div class="flex flex-wrap items-center p-2"></div> -->
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import loading from '@/mixins/Loading'
export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    name: {
      type: String,
      default: 'main-sidebar'
    },
    titleStyle:{
      type: Object,
      default: () => ({})
    },
    sidebarClass:{
      type: String,
      default: ''
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    }
  },
  methods: {
    close() {
      this.$store.dispatch('toggleSidebar', '')
    }
  },
  mixins:[loading],
  watch:{
    loading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}`)
      } else {
        this.closeLoading(`loading-${this.name}`)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.custom-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.sidebar-title {
  font-size: 18px;
}

.custom-sidebar.large {
  ::v-deep .vs-sidebar {
    width: 800px;
  }
}

.custom-sidebar.full {
  ::v-deep .vs-sidebar {
    width: 100%;
  }
}

.scroll-sidebar {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  //height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  height: 90vh;

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
